<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import Datatable from '@/components/Datatable'
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Cropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import { notify } from '@/helpers/notify' 

export default {
    page: {
        title: "Onay Bekleyenler Listesi",
    },
    mixins: [ datatableMixin ],
    components: { 
        Layout, 
        PageHeader,
        Datatable,
        Cropper
    },
    computed: {
       ...mapGetters('authfack',['userdata'])
    },
    data() {
     return {
            title: "ONAY BEKLEYENLER LİSTESİ",
            items: [
                { text: "ANASAYFA", href: "/" },
                { text: "ONAY BEKLEYENLER LİSTESİ", active: true }
            ],
            url: "/listeler/onay-listesi",
            buttons:[
                { title:"Kontrol Et",  func:this.control},
            ],  
            columns: [
                { name: '', key: 'action', orderable: false, width:10  },
                { name: 'Kullanıcı Adı', key: 'username' },
                { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                { name: 'Kurulduğu Tarihi', key: 'start_date', className: 'text-end', width: 150  },
                { name: 'Durum', key: 'status', className: 'text-end', width: 150  },
                { name: 'Telefon', key: 'phonenumber', className: 'text-end', width: 150  },
                { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                { name: 'Bağlantı', key: 'url', className: 'text-end', width: 250  },
            ],
            tableData: {
                detail: false,
                excel: false,
                    searchable:{
                        visible:true,
                        placeholder:"İsim Soyisim de Ara"
                    }
            },
            endpoint: '/listeler/onay-listesi',
            exportName: 'Onay Bekleyenler',
            controlItems: {},
            showCropper: false,
            croppedImage: null,
            check:{},
            editImageName: '',
            tagname: '',
            listeType: 1,
            searchParams: { tip: 1}
        };
    },
    methods: {

        async loadPage() {
       
            this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
            
            const response = await  this.$http.post(this.endpoint, { params: this.params, sort_column:this.sortColumn, sort_crder:this.sortOrder, search_query: this.searchQuery, search_params:this.searchParams });
            if (this.params.page === 1) {
                this.tableData.data = response.data.data;
            } else {
                this.tableData.data = [...this.tableData.data, ...response.data.data];
            }
        
            this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
            this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
        },

        expiredate(obj){
            return this.formatDate(obj.expiredate, "DD.MM.YYYY HH:mm")
        },
       
        control(props){
            this.controlItems = props
            this.$bvModal.show('kontrol-modal')
        },


        enableCropping(url, tagname) {
            this.tagname = tagname
            this.croppedImage = null
            this.showCropper = true
            this.editImageName = url
            this.imageUrl = `${this.$http.defaults.baseURL}/image/documents/${url}`
            this.$bvModal.show('crop-modal')
        },

        cropImage() {
            const canvas = this.$refs.cropper.getCroppedCanvas()
            this.croppedImage = canvas.toDataURL('image/jpeg')
            this.showCropper = false
        },
        
        onayla(){
            this.$http.post(this.endpoint + '?check_id=' + this.controlItems.contract_id , { ...this.check })
            .then(() => {
                this.loadPage()
                notify.success('Başarılı')
                this.$bvModal.hide('kontrol-modal')
            });
           
        },

        type(obj){
            let out = '';
            switch (obj.status) {
                case 'mbekliyor':
                out = '<label class="badge bg-success">Müşteri Bekleniyor</label>'
                break;
                case 'bekliyor':
                out = '<label class="badge bg-info">Bekliyor</label>'
                break;
            }
            return out 
        },

        async saveCroppedImage() {
            if (!this.croppedImage) return;

            // Base64 -> Blob dönüşümü
            const blob = this.dataURLtoBlob(this.croppedImage);

            // eslint-disable-next-line no-console
            console.log(blob)
            // Dosya olarak FormData'ya ekle
            const formData = new FormData();
            formData.append('image', blob, 'cropped.jpg'); 
            formData.append('contract_id', this.controlItems.contract_id);
            formData.append('tagname', this.tagname);
          
            try {
                const response = await this.$http.post('/image/crop', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });


                this.controlItems[this.tagname] = response.data.content
                notify.success('Kırpılmış görsel başarıyla yüklendi');
                this.$bvModal.hide('crop-modal');
            } catch (err) {
                notify.error('Yükleme sırasında hata oluştu');
            }
               
        },

        dataURLtoBlob(dataURL) {
            const byteString = atob(dataURL.split(',')[1]);
            const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ab], { type: mimeString });
        },

         sekme(idx){
            this.listeType = idx

            this.params= {
                    per_page: 50,
                    page: 1
                }

            this.sort.column= null
            this.sort.order= null
            this.searchQuery= ''

            if(idx == 1){
                this.searchParams = { tip: 1}
               
                this.buttons= [
                    { title:"Kontrol Et",  func:this.control},
                ],  
                this.items[1].title = 'KİMLİK BEKLEYENLER'
                this.columns= [
                    { name: '', key: 'action', orderable: false, width:10  },
                    { name: 'Kullanıcı Adı', key: 'username' },
                    { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                    { name: 'Kurulduğu Tarihi', key: 'start_date', className: 'text-end', width: 150  },
                    { name: 'Durum', key: 'status', className: 'text-end', width: 150  },
                    { name: 'Telefon', key: 'phonenumber', className: 'text-end', width: 150  },
                    { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                    { name: 'Bağlantı', key: 'url', className: 'text-end', width: 150  },
                ]

                this.loadPage()
            }

            if(idx == 2){
                this.searchParams = {tip:2}
                this.buttons= [],  
                this.items[1].title = 'SÖZLEŞME BEKLEYENLER'

                this.columns= [
                    { name: 'Kullanıcı Adı', key: 'username' },
                    { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                    { name: 'Kurulduğu Tarihi', key: 'start_date', className: 'text-end', width: 150  },
                    { name: 'Durum', key: 'status', className: 'text-end', width: 150  },
                    { name: 'Telefon', key: 'phonenumber', className: 'text-end', width: 150  },
                    { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                    { name: 'Bağlantı', key: 'url', className: 'text-end', width: 150  },
                ]
                this.loadPage()
            }

          
        }

    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />
    <b-modal id="kontrol-modal"  hide-header hide-footer size="lg">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th></th>
                    <th>Sistemde Olan</th>
                    <th>Müşteri Talebi</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>İsim</th>
                    <td>{{ controlItems.fname }}</td>
                    <td>{{ controlItems.contract_fname }}</td>
                    <td><input type="checkbox" v-model="check.fname" /></td>
                </tr>
                <tr>
                    <th>Soyisim</th>
                    <td>{{ controlItems.lname }}</td>
                    <td>{{ controlItems.contract_lname }}</td>
                    <td><input type="checkbox" v-model="check.name" /></td>
                </tr>
                <tr>
                    <th>Adres</th>
                    <td>{{ controlItems.address }}</td>
                    <td>{{ controlItems.contract_address }}</td>
                    <td><input type="checkbox" v-model="check.address" /></td>
                </tr>
                <tr>
                    <th>İl</th>
                    <td>{{ controlItems.district_name }}</td>
                    <td>{{ controlItems.contract_district }}</td>
                    <td><input type="checkbox" v-model="check.district" /></td>
                </tr>
                <tr>
                    <th>Bölge</th>
                    <td>{{ controlItems.quarter_name }}</td>
                    <td>{{ controlItems.contract_quarter }}</td>
                    <td><input type="checkbox" v-model="check.quarter" /></td>
                </tr>
                <tr>
                    <th>Doğum Tarihi</th>
                    <td>{{ controlItems.bday }}</td>
                    <td>{{ controlItems.birthday }}</td>
                    <td><input type="checkbox" v-model="check.birthday" /></td>
                </tr>
            </tbody>
        </table>
        
        <h5 class="mt-4">Onay Bekleyen Dökümanlar</h5>
        <div class="d-flex gap-3">
            <div class="col" v-if="controlItems.image1" style="position: relative;">
                Kimlik Ön
                <input type="checkbox" v-model="check.image1" />
                <img :src="`${$http.defaults.baseURL}/image/documents/${controlItems.image1}`" width="100%">
                <button style="position: absolute;bottom:2px;left:2px" class=" btn btn-info" @click="enableCropping(controlItems.image1, 'image1')">Editle</button>
            </div>
            <div class="col" v-if="controlItems.image2" style="position: relative;">
                Kimlik Arka
                <input type="checkbox" v-model="check.image2" />
                <img :src="`${$http.defaults.baseURL}/image/documents/${controlItems.image2}`" width="100%">
                <button style="position: absolute;bottom:2px;left:2px" class=" btn btn-info" @click="enableCropping(controlItems.image2, 'image2')">Editle</button>
            </div>
        </div>
        <div clasS="d-flex justify-content-between mt-2">
            <button class="btn btn-success" @click="onayla">Kaydet</button>
        </div>
    </b-modal>

    <b-modal id="crop-modal"  hide-header hide-footer size="lg">
        <div v-if="showCropper" class="text-center">
            <cropper
                ref="cropper"
                :src="imageUrl"
                :view-mode="1"
                :auto-crop-area="1"
                style="width: 100%;height: 100%;"
            />
            <button @click="cropImage" class=" btn btn-warning btn-block mt-2">Kırp</button>
        </div>

        <div v-if="croppedImage" class="text-center">
            <h4>Kırpılmış Görsel</h4>
            <img :src="croppedImage" style="max-width: 100%;" />
            <div class="d-flex justify-content-center mt-2">
                <button class="btn btn-outline-success me-2" @click="saveCroppedImage">Kırpılmışı Kaydet</button>
                <button class="btn btn-danger me-2">Kırpmayı İptal Et</button>
                <button class="btn btn-outline-info" @click="enableCropping(editImageName)">Tekrar Kırp</button>
            </div>
        </div>
    </b-modal>
    <div class="row"> 
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: listeType == 1 }" aria-current="page" href="#" @click.prevent="sekme(1)">Kimlik Bekleyenler</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: listeType == 2 }" aria-current="page" href="#" @click.prevent="sekme(2)">Sözleşme Bekleyenler</a>
                </li>
            </ul>
            <div>
                <Datatable 
                        :columns="columns" 
                        :tableData="tableData" 
                        @sort-column="handleSortColumn"
                        @search-query="reLoadPage"
                        :loading="isLoading"
                        :poading="pageLoading"
                        >

                    <template #fullname="{ row }">
                        {{  row.fname }} {{  row.lname }}
                    </template>
                    
                        
                    <template #status="{ row }">
                        <span v-html="type(row)"></span>
                    </template>


                    <template #phonenumber="{ row }">
                    <a :href="`tel:${row.phonenumber}`">{{ row.phonenumber }}</a>
                    </template>

                    <template #url="{ row }">
                        <span v-if="row.url">
                            <a :href="`${row.url}`" target="_blank">
                            {{ row.url }}
                            </a>
                        </span>
                    </template>

                    <template #action="{ row }">
                        <b-dropdown
                            toggle-class="font-size-16 p-0"
                            toggle-tag="a"
                            variant="white"
                            append-to-body
                            >
                            <template #button-content>
                            <i class="mdi mdi-dots-horizontal"></i>
                            </template>
                            <b-dropdown-item v-for="(button,i) in buttons" :key="i" @click="button.func(row)">{{ button.title }}</b-dropdown-item>
                        </b-dropdown>
                    </template>
                </Datatable>
            </div>
        </div>
    </div>
</Layout>
</template>